module.exports = __webpack_public_path__ + "img/Twitter_cool.2d8eb5e3.svg";